import { getIntrospectionQuery } from 'graphql'
import gql from 'graphql-tag'
import { GET_LIST, GET_ONE } from 'ra-core'
import { ALL_TYPES } from './constants'

export const isResourceIncluded = ({ include, type }) => {
  if (Array.isArray(include)) {
    return include.includes(type.name)
  }

  if (typeof include === 'function') {
    return include(type)
  }

  return false
}

export const isResourceExcluded = ({ exclude, type }) => {
  if (Array.isArray(exclude)) {
    return exclude.includes(type.name)
  }

  if (typeof exclude === 'function') {
    return exclude(type)
  }

  return false
}

/**
 * @param {ApolloClient} client The Apollo client
 * @param {Object} options The introspection options
 */
/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default async (client, options) => {
  const schema = options.schema
    ? options.schema
    : await client
        .query({
          fetchPolicy: 'network-only',
          query: gql`
            ${getIntrospectionQuery()}
          `,
        })
        .then(({ data: { __schema } }) => __schema)

  const queries = schema.types.reduce((acc, type) => {
    if (
      type.name !== (schema.queryType && schema.queryType.name) &&
      type.name !== (schema.mutationType && schema.mutationType.name)
    )
      return acc

    return [...acc, ...type.fields]
  }, [])

  const types = schema.types.filter(
    (type) =>
      type.name !== (schema.queryType && schema.queryType.name) &&
      type.name !== (schema.mutationType && schema.mutationType.name)
  )

  // operationNames return one name or a list of candidates.
  const names = (aorFetchType, type) => {
    const name = options.operationNames[aorFetchType]?.(type)
    return name ? [name].flat() : []
  }

  const isResource = (type) => {
    if (isResourceIncluded({ type, ...options })) return true
    if (isResourceExcluded({ type, ...options })) return false

    return (
      queries.some((query) => names(GET_LIST, type).includes(query.name)) &&
      queries.some((query) => names(GET_ONE, type).includes(query.name))
    )
  }

  const buildResource = (type) =>
    ALL_TYPES.reduce(
      (acc, aorFetchType) => ({
        ...acc,
        // The first candidate name the schema has wins.
        [aorFetchType]: names(aorFetchType, type)
          .map((name) => queries.find((query) => query.name === name))
          .find(Boolean),
      }),
      { type }
    )

  const filteredResources = types.filter(isResource)
  const resources = filteredResources.map(buildResource)

  return {
    types,
    queries,
    resources,
    schema,
  }
}
